import script from "./ILink.vue?vue&type=script&setup=true&lang=js"
export * from "./ILink.vue?vue&type=script&setup=true&lang=js"

import "./ILink.vue?vue&type=style&index=0&id=475a04e0&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-475a04e0"]])

export default __exports__